const widgets = [
  { i: "0", visible: true, widget: "CompanyDetail", static: true },
  { i: "1", minH: 3, visible: true, widget: "Note", name: "Note", category: "Generico" },
  { i: "2", minH: 3, visible: true, widget: "Doclavrecazi", name: "Documenti lavoratori", category: "Generico" },
  { i: "3", minH: 3, visible: true, widget: "DatiLavoratori", name: "Dati lavoratori ", category: "Lavoro" },
  { i: "4", minH: 3, visible: true, widget: "Ratei", name: "Ratei", category: "Lavoro" },
  { i: "5", minH: 3, visible: true, widget: "PresenzeAssenzeLavoratori", name: "Assenze e presenze lavoratori", category: "Lavoro" },
  { i: "6", minH: 3, visible: true, widget: "PresenzeAssenze", name: "Totale assenze e presenze", category: "Lavoro" },
  { i: "7", minH: 5, visible: true, widget: "ForzaAziendale", name: "Totale lavoratori retribuiti", category: "Lavoro" },
  { i: "8", minH: 8, visible: true, widget: "RetribuzioneTrattenute", name: "Retribuzione trattenute", category: "Lavoro" },
  { i: "9", minH: 5, visible: true, widget: "FilialiCantieri", name: "Filiali/Cantieri", category: "Lavoro" },
  { i: "10", minH: 16, visible: true, widget: "SalariCostiPersonale", name: "Salari e costi del personale", category: "Lavoro" },
  // { i: "11", minH: 8, visible: true, widget: "SituazioneEconomicaPatrimoniale", name: "Situazione economica patrimonale", category: "Contabilità" },

];

const mdLayout = [
  { x: 0, y: 0, w: 3, h: 4, ...widgets[0] },
  { x: 0, y: 4, w: 3, h: 4, ...widgets[1] },
  { x: 3, y: 0, w: 3, h: 4, ...widgets[2] },
  { x: 3, y: 4, w: 3, h: 5, ...widgets[3] },
  { x: 3, y: 9, w: 3, h: 5, ...widgets[4] },
  { x: 3, y: 14, w: 3, h: 5, ...widgets[5] },
  { x: 0, y: 8, w: 3, h: 5, ...widgets[6] },
  { x: 0, y: 13, w: 3, h: 6, ...widgets[7] },
  { x: 3, y: 19, w: 6, h: 8, ...widgets[8] },
  { x: 0, y: 25, w: 6, h: 5, ...widgets[9] },
  { x: 0, y: 25, w: 6, h: 16, ...widgets[10] },
  // { x: 0, y: 35, w: 6, h: 16, ...widgets[11] },
];

const lgLayout = [
  { x: 0, y: 0, w: 3, h: 4, ...widgets[0] },
  { x: 3, y: 0, w: 3, h: 4, ...widgets[1] },
  { x: 6, y: 0, w: 3, h: 4, ...widgets[2] },
  { x: 0, y: 4, w: 3, h: 5, ...widgets[3] },
  { x: 6, y: 4, w: 3, h: 5, ...widgets[4] },
  { x: 3, y: 4, w: 3, h: 5, ...widgets[5] },
  { x: 0, y: 14, w: 3, h: 3, ...widgets[6] },
  { x: 0, y: 9, w: 3, h: 5, ...widgets[7] },
  { x: 3, y: 9, w: 6, h: 8, ...widgets[8] },
  { x: 0, y: 25, w: 3, h: 5, ...widgets[9] },
  { x: 0, y: 25, w: 6, h: 16, ...widgets[10] },
  // { x: 0, y: 35, w: 6, h: 16, ...widgets[11] },
];

const xlLayout = [
  { x: 0, y: 0, w: 3, h: 4, ...widgets[0] },
  { x: 3, y: 0, w: 3, h: 4, ...widgets[1] },
  { x: 6, y: 0, w: 3, h: 3, ...widgets[2] },
  { x: 9, y: 0, w: 3, h: 6, ...widgets[3] },
  { x: 0, y: 4, w: 3, h: 5, ...widgets[4] },
  { x: 3, y: 4, w: 3, h: 5, ...widgets[5] },
  { x: 6, y: 3, w: 3, h: 3, ...widgets[6] },
  { x: 0, y: 9, w: 6, h: 5, ...widgets[7] },
  { x: 6, y: 6, w: 6, h: 8, ...widgets[8] },
  { x: 0, y: 25, w: 6, h: 5, ...widgets[9] },
  { x: 0, y: 25, w: 6, h: 16, ...widgets[10] },
  // { x: 0, y: 35, w: 6, h: 16, ...widgets[11] },
];

export const responsiveLayouts = {
  md: [...mdLayout],
  lg: [...lgLayout],
  xl: [...xlLayout],
}